export enum AlertVariants {
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
  SUCCESS = "success",
}

export default interface Alert {
  alertClearTimeout?: number;
  index: number;
  background?: string;
  heading: string;
  text?: string;
  variant: AlertVariants;
}
